import { css } from "lit";

export const windowsMePrimitives = css`
	:host {
		--desktop-field-color: var(--z-desktop-field, #406198);
		--shell-surface: var(--z-shell-surface, #d4d0c8);
		--shell-surface-light: var(--z-shell-surface-light, #ffffff);
		--shell-surface-mid: var(--z-shell-surface-mid, #808080);
		--shell-surface-dark: var(--z-shell-surface-dark, #404040);
		--shell-surface-deep: var(--z-shell-surface-deep, #111111);
		--shell-title-active-start: var(--z-shell-title-active-start, #0a246a);
		--shell-title-active-end: var(--z-shell-title-active-end, #a6caf0);
		--shell-title-inactive-start: var(--z-shell-title-inactive-start, #808080);
		--shell-title-inactive-end: var(--z-shell-title-inactive-end, #c0c0c0);
		--shell-selection: var(--z-shell-selection, #0a246a);
		--shell-selection-text: var(--z-shell-selection-text, #ffffff);
		--shell-text: var(--z-shell-text, #111111);
		--shell-text-muted: var(--z-shell-text-muted, #525252);
		--shell-disabled: var(--z-shell-disabled, #7d7d7d);
		--shell-focus: var(--z-shell-focus, #0a246a);
		--shell-dock-height: var(--z-shell-dock-height, 82px);
		--shell-font: var(
			--z-shell-font,
			Tahoma,
			"MS Sans Serif",
			"Segoe UI",
			sans-serif
		);
		font-family: var(--shell-font);
		color: var(--shell-text);
	}

	.pixel-icon {
		display: block;
		flex: none;
		image-rendering: pixelated;
		shape-rendering: crispEdges;
	}

	.raised-panel {
		background: var(--shell-surface);
		border-top: 1px solid var(--shell-surface-light);
		border-left: 1px solid var(--shell-surface-light);
		border-right: 1px solid var(--shell-surface-dark);
		border-bottom: 1px solid var(--shell-surface-dark);
		box-shadow:
			inset -1px -1px 0 0 var(--shell-surface-mid),
			inset 1px 1px 0 0 var(--shell-surface-light);
	}

	.sunken-panel {
		background: var(--shell-surface);
		border-top: 1px solid var(--shell-surface-dark);
		border-left: 1px solid var(--shell-surface-dark);
		border-right: 1px solid var(--shell-surface-light);
		border-bottom: 1px solid var(--shell-surface-light);
		box-shadow:
			inset 1px 1px 0 0 var(--shell-surface-mid),
			inset -1px -1px 0 0 var(--shell-surface-light);
	}

	.bevel-button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-height: 22px;
		padding: 0 7px;
		font: 400 11px/1 var(--shell-font);
		color: var(--shell-text);
		background: var(--shell-surface);
		border-top: 1px solid var(--shell-surface-light);
		border-left: 1px solid var(--shell-surface-light);
		border-right: 1px solid var(--shell-surface-dark);
		border-bottom: 1px solid var(--shell-surface-dark);
		box-shadow:
			inset -1px -1px 0 0 var(--shell-surface-mid),
			inset 1px 1px 0 0 var(--shell-surface-light);
		cursor: default;
	}

	.bevel-button[aria-pressed="true"],
	.bevel-button[data-active="true"] {
		border-top: 1px solid var(--shell-surface-dark);
		border-left: 1px solid var(--shell-surface-dark);
		border-right: 1px solid var(--shell-surface-light);
		border-bottom: 1px solid var(--shell-surface-light);
		box-shadow:
			inset 1px 1px 0 0 var(--shell-surface-mid),
			inset -1px -1px 0 0 var(--shell-surface-light);
		padding-top: 1px;
		padding-left: 1px;
	}

	.bevel-button:focus-visible,
	.focus-ring:focus-visible {
		outline: 1px dotted var(--shell-focus);
		outline-offset: -3px;
	}

	.caption-button {
		display: inline-grid;
		place-items: center;
		width: 18px;
		height: 18px;
		padding: 0;
		font: 700 11px/1 "Marlett", var(--shell-font);
	}

	.visually-hidden {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border: 0;
	}
`;
